import { Reveal } from "@/components/site/Reveal";
import { BrandMark, Fern } from "@/components/site/BrandMark";
import { API } from "@/lib/api";
import { ShieldCheck, HeartHandshake, Sparkles } from "lucide-react";

const values = [
  { icon: ShieldCheck, label: "Ética & sigilo" },
  { icon: HeartHandshake, label: "Escuta acolhedora" },
  { icon: Sparkles, label: "Foco em você" },
];

const DEFAULT_TITLE = "Cuidar da mente é um ato de coragem";
const DEFAULT_TEXT =
  "Sou psicóloga clínica e acredito que a psicologia é acolhimento, compreensão e transformação. Meu trabalho é oferecer um espaço seguro, livre de julgamentos, onde você possa se entender, se acolher e crescer no seu próprio tempo.\n\nAtendo de forma totalmente online, com escuta atenta, ética e sigilo — para que, de onde você estiver, possamos construir juntas(os) um caminho de mais equilíbrio, autoconhecimento e bem-estar.";

export default function About({ content }) {
  const title = content?.about_title || DEFAULT_TITLE;
  const text = content?.about_text || DEFAULT_TEXT;
  const photo = content?.about_photo_path;
  const paragraphs = text.split(/\n\s*\n/);

  // split title so last word gets script styling
  const words = title.trim().split(" ");
  const lead = words.slice(0, -1).join(" ");
  const last = words.slice(-1);

  return (
    <section id="sobre" className="relative bg-[#F5F0E6] py-24 sm:py-32 overflow-hidden" data-testid="about-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal className="order-2 lg:order-1">
          <div className="relative mx-auto max-w-md">
            <div className="absolute -inset-3 rounded-[2rem] border border-[#5B6E5B]/20" />
            <div className="relative aspect-[4/5] rounded-[1.8rem] overflow-hidden shadow-[0_20px_60px_rgba(91,110,91,0.12)] grid place-items-center bg-gradient-to-b from-[#FDFBF7] to-[#EDE6D6]">
              {photo ? (
                <img src={`${API}/files/${photo}`} alt="Tacilaine Almeida" className="absolute inset-0 w-full h-full object-cover" data-testid="about-photo" />
              ) : (
                <>
                  <Fern color="#5B6E5B" opacity={0.18} className="absolute -left-6 bottom-0 w-40" />
                  <Fern color="#8A9A82" opacity={0.15} className="absolute -right-8 top-2 w-44 scale-x-[-1]" />
                  <div className="relative text-center px-8">
                    <BrandMark className="w-20 h-20 mx-auto mb-5" />
                    <p className="font-script text-4xl text-[#5B6E5B] leading-none">Tacilaine Almeida</p>
                    <p className="font-body text-[11px] tracking-[0.35em] uppercase text-[#7A8A7A] mt-2">Psicóloga · CRP 08/33677</p>
                  </div>
                </>
              )}
            </div>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <span className="font-body text-xs tracking-[0.4em] uppercase text-[#C87A5E]">Sobre</span>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl text-[#2C332A] leading-tight text-balance">
              {lead} <span className="font-script text-[#5B6E5B] text-5xl sm:text-6xl">{last}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="mt-7 space-y-5 font-body text-[#4A5D4E] leading-relaxed max-w-xl">
              {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-9 flex flex-wrap gap-3">
              {values.map((v) => (
                <div key={v.label} className="inline-flex items-center gap-2.5 rounded-full bg-white/70 border border-[#5B6E5B]/10 px-5 py-2.5">
                  <v.icon className="w-4 h-4 text-[#5B6E5B]" strokeWidth={1.5} />
                  <span className="font-body text-sm text-[#4A5D4E]">{v.label}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
